export default {"src":"/_next/static/media/fit-to-screen-enabled.9f94cffa.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};